/** @module 工具模块-通用工具方法 */

/**
 * @description 工具函数-时间格式化
 * @function
 * @param {date} 日期
 * @return {string} 格式化日期
 */
export const formatTime = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  const milliSeconds = String(date.getMilliseconds()).padStart(3, '0');

  return `${[year, month, day].map(formatNumber).join('/')} ${[hour, minute, second]
    .map(formatNumber)
    .join(':')}.${milliSeconds}`;
};

/**
 * @description 工具函数-数字格式化
 * @param n
 * @returns {string} 数字加0
 */
export const formatNumber = (n) => {
  return n < 10 ? `0${n}` : `${n}`;
};

/**
 * @description 工具函数-判断数据类型
 * @method
 * @param {number} 数字
 * @return {string} 数字加0
 */

const getDataType = (action) => {
  if (action) {
    return Object.prototype.toString.call(action).slice(8, -1);
  }
  throw 'action undefined';
};

export const isObject = (action) => {
  return getDataType(action) === 'object';
};

export const isArray = (action) => {
  return getDataType(action) === 'array';
};
